// 饼图数据
export const pieData = {
    data: [{
        value: 335,
        name: '直接访问',
        unit: '千万'
    },
    {
        value: 310,
        name: '邮件营销',
        unit: '千万'
    },
    {
        value: 234,
        name: '联盟广告',
        unit: '千万'
    },
    {
        value: 135,
        name: '视频广告',
        unit: '千万'
    },
    {
        value: 1548,
        name: '搜索引擎',
        unit: '千万'
    }],
    colorSeries: () =>  {
        return ['#2D8CF0', '#00D2B3', '#FBA900', '#F27036', '#B52851'];
    }
};
// 折线柱状数据
export const lineBarData = {
    data: [820, 932, 901, 934, 1290, 1330, 1320],
    xData: {
        data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
    }
};
// 气泡数据
export const bubbleData = [
    [
        [1,55,9,56,0.46,18,6,'良'],
        [2,25,11,21,0.65,34,9,'优'],
        [3,56,7,63,0.3,14,5,'良'],
        [4,33,7,29,0.33,16,6,'优'],
        [5,42,24,44,0.76,40,16,'优'],
        [6,82,58,90,1.77,68,33,'良'],
        [7,74,49,77,1.46,48,27,'良'],
        [8,78,55,80,1.29,59,29,'良'],
        [9,267,216,280,4.8,108,64,'重度污染'],
        [10,185,127,216,2.52,61,27,'中度污染'],
        [11,39,19,38,0.57,31,15,'优'],
        [12,41,11,40,0.43,21,7,'优'],
        [13,64,38,74,1.04,46,22,'良'],
        [14,108,79,120,1.7,75,41,'轻度污染'],
        [15,108,63,116,1.48,44,26,'轻度污染'],
        [16,33,6,29,0.34,13,5,'优'],
        [17,94,66,110,1.54,62,31,'良'],
        [18,186,142,192,3.88,93,79,'中度污染'],
        [19,57,31,54,0.96,32,14,'良'],
        [20,22,8,17,0.48,23,10,'优'],
        [21,39,15,36,0.61,29,13,'优'],
        [22,94,69,114,2.08,73,39,'良'],
        [23,99,73,110,2.43,76,48,'良'],
        [24,31,12,30,0.5,32,16,'优'],
        [25,42,27,43,1,53,22,'优'],
        [26,154,117,157,3.05,92,58,'中度污染'],
        [27,234,185,230,4.09,123,69,'重度污染'],
        [28,160,120,186,2.77,91,50,'中度污染'],
        [29,134,96,165,2.76,83,41,'轻度污染'],
        [30,52,24,60,1.03,50,21,'良'],
        [31,46,5,49,0.28,10,6,'优']
    ],
    [
        [1,26,37,27,1.163,27,13,'优'],
        [2,85,62,71,1.195,60,8,'良'],
        [3,78,38,74,1.363,37,7,'良'],
        [4,21,21,36,0.634,40,9,'优'],
        [5,41,42,46,0.915,81,13,'优'],
        [6,56,52,69,1.067,92,16,'良'],
        [7,64,30,28,0.924,51,2,'良'],
        [8,55,48,74,1.236,75,26,'良'],
        [9,76,85,113,1.237,114,27,'良'],
        [10,91,81,104,1.041,56,40,'良'],
        [11,84,39,60,0.964,25,11,'良'],
        [12,64,51,101,0.862,58,23,'良'],
        [13,70,69,120,1.198,65,36,'良'],
        [14,77,105,178,2.549,64,16,'良'],
        [15,109,68,87,0.996,74,29,'轻度污染'],
        [16,73,68,97,0.905,51,34,'良'],
        [17,54,27,47,0.592,53,12,'良'],
        [18,51,61,97,0.811,65,19,'良'],
        [19,91,71,121,1.374,43,18,'良'],
        [20,73,102,182,2.787,44,19,'良'],
        [21,73,50,76,0.717,31,20,'良'],
        [22,84,94,140,2.238,68,18,'良'],
        [23,93,77,104,1.165,53,7,'良'],
        [24,99,130,227,3.97,55,15,'良'],
        [25,146,84,139,1.094,40,17,'轻度污染'],
        [26,113,108,137,1.481,48,15,'轻度污染'],
        [27,81,48,62,1.619,26,3,'良'],
        [28,56,48,68,1.336,37,9,'良'],
        [29,82,92,174,3.29,0,13,'良'],
        [30,106,116,188,3.628,101,16,'轻度污染'],
        [31,118,50,0,1.383,76,11,'轻度污染']
    ],
    [
        [1,91,45,125,0.82,34,23,'良'],
        [2,65,27,78,0.86,45,29,'良'],
        [3,83,60,84,1.09,73,27,'良'],
        [4,109,81,121,1.28,68,51,'轻度污染'],
        [5,106,77,114,1.07,55,51,'轻度污染'],
        [6,109,81,121,1.28,68,51,'轻度污染'],
        [7,106,77,114,1.07,55,51,'轻度污染'],
        [8,89,65,78,0.86,51,26,'良'],
        [9,53,33,47,0.64,50,17,'良'],
        [10,80,55,80,1.01,75,24,'良'],
        [11,117,81,124,1.03,45,24,'轻度污染'],
        [12,99,71,142,1.1,62,42,'良'],
        [13,95,69,130,1.28,74,50,'良'],
        [14,116,87,131,1.47,84,40,'轻度污染'],
        [15,108,80,121,1.3,85,37,'轻度污染'],
        [16,134,83,167,1.16,57,43,'轻度污染'],
        [17,79,43,107,1.05,59,37,'良'],
        [18,71,46,89,0.86,64,25,'良'],
        [19,97,71,113,1.17,88,31,'良'],
        [20,84,57,91,0.85,55,31,'良'],
        [21,87,63,101,0.9,56,41,'良'],
        [22,104,77,119,1.09,73,48,'轻度污染'],
        [23,87,62,100,1,72,28,'良'],
        [24,168,128,172,1.49,97,56,'中度污染'],
        [25,65,45,51,0.74,39,17,'良'],
        [26,39,24,38,0.61,47,17,'优'],
        [27,39,24,39,0.59,50,19,'优'],
        [28,93,68,96,1.05,79,29,'良'],
        [29,188,143,197,1.66,99,51,'中度污染'],
        [30,174,131,174,1.55,108,50,'中度污染'],
        [31,187,143,201,1.39,89,53,'中度污染']
    ]
];
// 折线数据
export const lineData = {
    data: [820, 932, 901, 934, 1290, 1330, 1320],
    xData: {
        data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
    }
};
//堆积折线图数据
export const linesData = {
    data: [
        [120, 132, 101, 134, 90, 230, 210],
        [220, 182, 191, 234, 290, 330, 310],
        [150, 232, 201, 154, 190, 330, 410],
        [320, 332, 301, 334, 390, 330, 320],
        [820, 932, 901, 934, 1290, 1330, 1320]
    ],
    // legend:['邮件营销', '联盟广告', '视频广告', '直接访问', '搜索引擎'],
    // legend: ['邮件营销', '联盟广告', '视频广告', '直接访问', '搜索引擎'],
    xData: ['周一', '周二', '周三', '周四', '周五', '周六', '周日']
};
//treemap图数据
export const treemapData = {
    data: [{
        name: 'nodeA',            // First tree
        value: 10,
        children: [{
            name: 'nodeAa',       // First leaf of first tree
            value: 4
        }, {
            name: 'nodeAb',       // Second leaf of first tree
            value: 6
        }]
    }, {
        name: 'nodeB',            // Second tree
        value: 20,
        children: [{
            name: 'nodeBa',       // Son of first tree
            value: 20,
            children: [{
                name: 'nodeBa1',  // Granson of first tree
                value: 20
            }]
        }]
    }]
};
// 排行列表数据
export const rankList = [
    {
        option: '0-5公里',
        color: '#038CFB',
        percent: 59.4,
        total: 3527,
        key: 1
    }, {
        option: '20-30公里',
        color: '#0091FF',
        percent: 10.49,
        total: 25,
        key: 4
    }, {
        option: '5-10公里',
        color: '#24F2D8',
        percent: 35.4,
        total: 1292,
        key: 2
    },  {
        option: '30公里以上',
        color: '#0091FF',
        percent: 5.04,
        total: 2,
        key: 5
    }, {
        option: '10-20公里',
        color: '#FFB726',
        percent: 24.6,
        total: 235,
        key: 3
    }
];
// 雄安无痕折线图数据
export const noLineData = {
    xData: ['10.28', '10.29', '10.30', '10.31', '11.1', '11.2', '11.3'],
    data: [728, 1014, 806, 986, 1294, 974, 734]
};
// 雄安折线图数据
export const xaLineData = {
    data: [2894,3402,2871,3081,3326,2258,2112],
    xData: ['周一', '周二', '周三', '周四', '周五', '周六', '周日']
};
// 雄安24h流量数据
export const xaFlowLineData = {
    xData: ['00:00', '01:00', '02:00', '03:00', '04:00', '05:00', '06:00', '07:00', '08:00', '09:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00', '17:00', '18:00', '19:00', '20:00', '21:00', '22:00', '23:00'],
    data: [3397, 2255, 2016, 1401, 700, 1220, 4955, 8150, 5558, 5300, 5848, 6057, 5831, 8282, 8052, 6800, 5291, 4247, 4368, 4219, 3610, 4979, 4508, 3142]
};
// 雄安柱状图数据
export const xaBarData = [
    { name: '上海', value: 2766 },
    { name: '云南', value: 2729 },
    { name: '内蒙古', value: 599 },
    { name: '北京', value: 252 },
    { name: '吉林', value: 202 },
    { name: '四川', value: 190 },
    { name: '天津', value: 188 },
    { name: '宁夏', value: 179 },
    { name: '安徽', value: 156 },
    { name: '山东', value: 126 }
];
// 雄安散点图数据
export const scatterData = [
    [8.0, 6.95],
    [13.0, 7.58],
    [9.0, 8.81],
    [11.0, 8.33],
    [14.0, 9.96],
    [6.0, 7.24],
    [4.0, 4.26],
    [12.0, 10.84],
    [7.0, 4.82],
    [2.0, 5.68],
    [1.0, 2.68],
    [3.0, 4.68],
];
// 武汉流入数据
export const rankInData = [
    {name:'河南省',total:'408678',percent:'12.39'},
    {name:'广东省',total:'349144',percent:'10.59'},
    {name:'湖南省',total:'261355',percent:'7.92'},
    {name:'江苏省',total:'188055',percent:'5.70'},
    {name:'安徽省',total:'177816',percent:'5.39'},
    {name:'四川省',total:'168709',percent:'5.12'},
    {name:'江西省',total:'165454',percent:'5.02'},
    {name:'山东省',total:'157416',percent:'4.77'},
    {name:'浙江省',total:'152962',percent:'4.64'},
    {name:'北京市',total:'131386',percent:'3.98'},
    {name:'河北省',total:'123183',percent:'3.74'},
    {name:'上海市',total:'112917',percent:'3.42'},
    {name:'福建省',total:'102151',percent:'3.10'},
    {name:'重庆市',total:'93010',percent:'2.82'},
    {name:'广西壮族自治区',total:'82186',percent:'2.49'},
    {name:'陕西省',total:'81465',percent:'2.47'},
    {name:'山西省',total:'74647',percent:'2.26'},
    {name:'贵州省',total:'65905',percent:'2.00'},
    {name:'辽宁省',total:'60213',percent:'1.83'},
    {name:'云南省',total:'57124',percent:'1.73'},
    {name:'黑龙江省',total:'43008',percent:'1.30'},
    {name:'甘肃省',total:'39505',percent:'1.20'},
    {name:'海南省',total:'39498',percent:'1.20'},
    {name:'疆维吾尔自治区',total:'35865',percent:'1.09'},
    {name:'吉林省',total:'33172',percent:'1.01'},
    {name:'内蒙古自治区',total:'31912',percent:'0.97'},
    {name:'天津市',total:'26767',percent:'0.81'},
    {name:'宁夏回族自治区',total:'11700',percent:'0.35'},
    {name:'青海省',total:'8134',percent:'0.25'},
    {name:'台湾省',total:'4338',percent:'0.13'},
    {name:'香港特别行政区',total:'4158',percent:'0.13'},
    {name:'西藏自治区',total:'3588',percent:'0.11'},
    {name:'澳门特别行政区',total:'2635',percent:'0.08'}
];
// 武汉流出数据
export const rankOutData = [
    {name:'广州市',total:'139048',percent:'4.22'},
    {name:'北京市',total:'131386',percent:'3.98'},
    {name:'上海市',total:'112917',percent:'3.42'},
    {name:'重庆市',total:'93010',percent:'2.82'},
    {name:'信阳市',total:'74862',percent:'2.27'},
    {name:'深圳市',total:'71761',percent:'2.18'},
    {name:'长沙市',total:'71272',percent:'2.16'},
    {name:'成都市',total:'51909',percent:'1.57'},
    {name:'郑州市',total:'51640',percent:'1.57'},
    {name:'驻马店市',total:'45156',percent:'1.37'},
    {name:'合肥市',total:'44061',percent:'1.34'},
    {name:'南阳市',total:'41758',percent:'1.27'},
    {name:'杭州市',total:'41256',percent:'1.25'},
    {name:'南京市',total:'38739',percent:'1.17'},
    {name:'岳阳市',total:'36963',percent:'1.12'},
    {name:'南昌市',total:'35577',percent:'1.08'},
    {name:'西安市',total:'33927',percent:'1.03'},
    {name:'九江市',total:'32437',percent:'0.98'},
    {name:'苏州市',total:'30408',percent:'0.92'},
    {name:'周口市',total:'30321',percent:'0.92'},
    {name:'天津市',total:'26767',percent:'0.81'},
    {name:'温州市',total:'24474',percent:'0.74'},
    {name:'福州市',total:'23788',percent:'0.72'},
    {name:'石家庄市',total:'23395',percent:'0.71'},
    {name:'东莞市',total:'23056',percent:'0.70'},
    {name:'衡阳市',total:'21898',percent:'0.66'},
    {name:'常德市',total:'21868',percent:'0.66'},
    {name:'阜阳市',total:'21504',percent:'0.65'},
    {name:'安庆市',total:'21481',percent:'0.65'},
    {name:'洛阳市',total:'21064',percent:'0.64'},
    {name:'商丘市',total:'20557',percent:'0.62'},
    {name:'泉州市',total:'20077',percent:'0.61'},
    {name:'昆明市',total:'19234',percent:'0.58'},
    {name:'宁波市',total:'18973',percent:'0.58'},
    {name:'佛山市',total:'18691',percent:'0.57'},
    {name:'厦门市',total:'18439',percent:'0.56'},
    {name:'南宁市',total:'18273',percent:'0.55'},
    {name:'青岛市',total:'18073',percent:'0.55'},
    {name:'保定市',total:'17638',percent:'0.53'},
    {name:'无锡市',total:'17581',percent:'0.53'},
    {name:'菏泽市',total:'17433',percent:'0.53'},
    {name:'邯郸市',total:'17331',percent:'0.53'},
    {name:'新乡市',total:'17283',percent:'0.52'},
    {name:'济南市',total:'17259',percent:'0.52'},
    {name:'赣州市',total:'17052',percent:'0.52'},
    {name:'哈尔滨市',total:'17044',percent:'0.52'},
    {name:'宜春市',total:'16818',percent:'0.51'},
    {name:'上饶市',total:'16476',percent:'0.50'},
    {name:'许昌市',total:'16099',percent:'0.49'},
    {name:'六安市',total:'16008',percent:'0.49'},
    {name:'徐州市',total:'15891',percent:'0.48'},
    {name:'安阳市',total:'15658',percent:'0.47'},
    {name:'达州市',total:'15642',percent:'0.47'},
    {name:'邵阳市',total:'15522',percent:'0.47'},
    {name:'沈阳市',total:'15469',percent:'0.47'},
    {name:'吉安市',total:'15127',percent:'0.46'},
    {name:'株洲市',total:'15069',percent:'0.46'},
    {name:'南通市',total:'14863',percent:'0.45'},
    {name:'太原市',total:'14698',percent:'0.45'},
    {name:'平顶山市',total:'14676',percent:'0.44'},
    {name:'台州市',total:'14416',percent:'0.44'},
    {name:'金华市',total:'14283',percent:'0.43'},
    {name:'漯河市',total:'14155',percent:'0.43'},
    {name:'贵阳市',total:'14002',percent:'0.42'},
    {name:'南充市',total:'13933',percent:'0.42'},
    {name:'长春市',total:'13734',percent:'0.42'},
    {name:'临沂市',total:'13683',percent:'0.41'},
    {name:'济宁市',total:'13318',percent:'0.40'},
    {name:'大连市',total:'13281',percent:'0.40'},
    {name:'开封市',total:'13059',percent:'0.40'},
    {name:'益阳市',total:'12805',percent:'0.39'},
    {name:'惠州市',total:'12706',percent:'0.39'},
    {name:'邢台市',total:'12577',percent:'0.38'},
    {name:'娄底市',total:'12376',percent:'0.38'},
    {name:'抚州市',total:'12348',percent:'0.37'},
    {name:'海口市',total:'12217',percent:'0.37'},
    {name:'桂林市',total:'12195',percent:'0.37'},
    {name:'三亚市',total:'12148',percent:'0.37'},
    {name:'遵义市',total:'11490',percent:'0.35'},
    {name:'潍坊市',total:'11410',percent:'0.35'},
    {name:'焦作市',total:'11127',percent:'0.34'},
    {name:'常州市',total:'11101',percent:'0.34'},
    {name:'郴州市',total:'11017',percent:'0.33'},
    {name:'珠海市',total:'10837',percent:'0.33'},
    {name:'泰州市',total:'10830',percent:'0.33'},
    {name:'乌鲁木齐市',total:'10729',percent:'0.33'},
    {name:'湘潭市',total:'10716',percent:'0.32'},
    {name:'烟台市',total:'10671',percent:'0.32'},
    {name:'绍兴市',total:'10623',percent:'0.32'},
    {name:'怀化市',total:'10609',percent:'0.32'},
    {name:'永州市',total:'10587',percent:'0.32'},
    {name:'盐城市',total:'10426',percent:'0.32'},
    {name:'扬州市',total:'10222',percent:'0.31'},
    {name:'莆田市',total:'9999',percent:'0.30'},
    {name:'廊坊市',total:'9846',percent:'0.30'},
    {name:'兰州市',total:'9777',percent:'0.30'},
    {name:'泰安市',total:'9733',percent:'0.30'},
    {name:'沧州市',total:'9639',percent:'0.29'},
    {name:'绵阳市',total:'9589',percent:'0.29'},
    {name:'芜湖市',total:'9585',percent:'0.29'},
    {name:'嘉兴市',total:'9462',percent:'0.29'},
    {name:'安康市',total:'9280',percent:'0.28'},
    {name:'亳州市',total:'9082',percent:'0.28'},
    {name:'中山市',total:'9072',percent:'0.28'},
    {name:'宿州市',total:'8998',percent:'0.27'},
    {name:'濮阳市',total:'8974',percent:'0.27'},
    {name:'咸阳市',total:'8913',percent:'0.27'},
    {name:'运城市',total:'8790',percent:'0.27'},
    {name:'宜宾市',total:'8412',percent:'0.26'},
    {name:'柳州市',total:'8401',percent:'0.25'},
    {name:'唐山市',total:'8269',percent:'0.25'},
    {name:'毕节市',total:'8218',percent:'0.25'},
    {name:'淄博市',total:'8076',percent:'0.24'},
    {name:'聊城市',total:'8016',percent:'0.24'},
    {name:'滁州市',total:'7969',percent:'0.24'},
    {name:'巴中市',total:'7633',percent:'0.23'},
    {name:'镇江市',total:'7621',percent:'0.23'},
    {name:'汕头市',total:'7600',percent:'0.23'},
    {name:'临汾市',total:'7564',percent:'0.23'},
    {name:'北海市',total:'7513',percent:'0.23'},
    {name:'连云港市',total:'7242',percent:'0.22'},
    {name:'黔东南苗族侗族自治州',total:'7237',percent:'0.22'},
    {name:'大同市',total:'7179',percent:'0.22'},
    {name:'广安市',total:'7158',percent:'0.22'},
    {name:'玉林市',total:'7143',percent:'0.22'},
    {name:'张家口市',total:'7116',percent:'0.22'},
    {name:'蚌埠市',total:'7107',percent:'0.22'},
    {name:'汉中市',total:'7087',percent:'0.21'},
    {name:'晋中市',total:'7035',percent:'0.21'},
    {name:'衡水市',total:'6991',percent:'0.21'},
    {name:'渭南市',total:'6913',percent:'0.21'},
    {name:'长治市',total:'6852',percent:'0.21'},
    {name:'湖州市',total:'6814',percent:'0.21'},
    {name:'淮安市',total:'6780',percent:'0.21'},
    {name:'漳州市',total:'6747',percent:'0.20'},
    {name:'德州市',total:'6718',percent:'0.20'},
    {name:'曲靖市',total:'6600',percent:'0.20'},
    {name:'三明市',total:'6484',percent:'0.20'},
    {name:'铜仁市',total:'6436',percent:'0.20'},
    {name:'淮南市',total:'6429',percent:'0.19'},
    {name:'宿迁市',total:'6348',percent:'0.19'},
    {name:'宝鸡市',total:'6243',percent:'0.19'},
    {name:'遂宁市',total:'6213',percent:'0.19'},
    {name:'景德镇市',total:'6163',percent:'0.19'},
    {name:'呼和浩特市',total:'6157',percent:'0.19'},
    {name:'枣庄市',total:'6118',percent:'0.19'},
    {name:'江门市',total:'6052',percent:'0.18'},
    {name:'湘西土家族苗族自治州',total:'6027',percent:'0.18'},
    {name:'银川市',total:'6000',percent:'0.18'},
    {name:'宁德市',total:'5971',percent:'0.18'},
    {name:'南平市',total:'5944',percent:'0.18'},
    {name:'韶关市',total:'5938',percent:'0.18'},
    {name:'黔南布依族苗族自治州',total:'5935',percent:'0.18'},
    {name:'内江市',total:'5913',percent:'0.18'},
    {name:'湛江市',total:'5835',percent:'0.18'},
    {name:'晋城市',total:'5827',percent:'0.18'},
    {name:'贵港市',total:'5815',percent:'0.18'},
    {name:'萍乡市',total:'5796',percent:'0.18'},
    {name:'泸州市',total:'5793',percent:'0.18'},
    {name:'衢州市',total:'5721',percent:'0.17'},
    {name:'赤峰市',total:'5649',percent:'0.17'},
    {name:'茂名市',total:'5581',percent:'0.17'},
    {name:'三门峡市',total:'5542',percent:'0.17'},
    {name:'揭阳市',total:'5536',percent:'0.17'},
    {name:'马鞍山市',total:'5517',percent:'0.17'},
    {name:'昭通市',total:'5503',percent:'0.17'},
    {name:'吕梁市',total:'5485',percent:'0.17'},
    {name:'清远市',total:'5476',percent:'0.17'},
    {name:'德阳市',total:'5469',percent:'0.17'},
    {name:'承德市',total:'5340',percent:'0.16'},
    {name:'西宁市',total:'5326',percent:'0.16'},
    {name:'天水市',total:'5218',percent:'0.16'},
    {name:'自贡市',total:'5050',percent:'0.15'},
    {name:'眉山市',total:'5049',percent:'0.15'},
    {name:'秦皇岛市',total:'5038',percent:'0.15'},
    {name:'宣城市',total:'4965',percent:'0.15'},
    {name:'吉林市',total:'4912',percent:'0.15'},
    {name:'鹤壁市',total:'4875',percent:'0.15'},
    {name:'大理白族自治州',total:'4870',percent:'0.15'},
    {name:'包头市',total:'4830',percent:'0.15'},
    {name:'忻州市',total:'4828',percent:'0.15'},
    {name:'丽水市',total:'4821',percent:'0.15'},
    {name:'龙岩市',total:'4699',percent:'0.14'},
    {name:'张家界市',total:'4623',percent:'0.14'},
    {name:'乐山市',total:'4572',percent:'0.14'},
    {name:'六盘水市',total:'4510',percent:'0.14'},
    {name:'广元市',total:'4452',percent:'0.13'},
    {name:'滨州市',total:'4429',percent:'0.13'},
    {name:'资阳市',total:'4383',percent:'0.13'},
    {name:'池州市',total:'4344',percent:'0.13'},
    {name:'台湾省',total:'4338',percent:'0.13'},
    {name:'齐齐哈尔市',total:'4333',percent:'0.13'},
    {name:'西南布依族苗族自治州',total:'4249',percent:'0.13'},
    {name:'肇庆市',total:'4185',percent:'0.13'},
    {name:'香港特别行政区',total:'4158',percent:'0.13'},
    {name:'鞍山市',total:'4096',percent:'0.12'},
    {name:'伊犁哈萨克自治州',total:'4042',percent:'0.12'},
    {name:'淮北市',total:'4023',percent:'0.12'},
    {name:'鹰潭市',total:'4015',percent:'0.12'},
    {name:'梅州市',total:'3967',percent:'0.12'},
    {name:'河池市',total:'3891',percent:'0.12'},
    {name:'日照市',total:'3858',percent:'0.12'},
    {name:'安顺市',total:'3825',percent:'0.12'},
    {name:'定西市',total:'3808',percent:'0.12'},
    {name:'东营市',total:'3754',percent:'0.11'},
    {name:'梧州市',total:'3736',percent:'0.11'},
    {name:'葫芦岛市',total:'3714',percent:'0.11'},
    {name:'朔州市',total:'3651',percent:'0.11'},
    {name:'新余市',total:'3643',percent:'0.11'},
    {name:'大庆市',total:'3616',percent:'0.11'},
    {name:'锦州市',total:'3613',percent:'0.11'},
    {name:'凉山彝族自治州',total:'3603',percent:'0.11'},
    {name:'绥化市',total:'3442',percent:'0.10'},
    {name:'铜陵市',total:'3403',percent:'0.10'},
    {name:'丽江市',total:'3393',percent:'0.10'},
    {name:'黄山市',total:'3337',percent:'0.10'},
    {name:'朝阳市',total:'3328',percent:'0.10'},
    {name:'延边朝鲜族自治州',total:'3312',percent:'0.10'},
    {name:'百色市',total:'3237',percent:'0.10'},
    {name:'红河哈尼族彝族自治州',total:'3222',percent:'0.10'},
    {name:'昌吉回族自治州',total:'3202',percent:'0.10'},
    {name:'榆林市',total:'3198',percent:'0.10'},
    {name:'牡丹江市',total:'3193',percent:'0.10'},
    {name:'河源市',total:'3193',percent:'0.10'},
    {name:'庆阳市',total:'3168',percent:'0.10'},
    {name:'阳江市',total:'3144',percent:'0.10'},
    {name:'钦州市',total:'3121',percent:'0.09'},
    {name:'潮州市',total:'3103',percent:'0.09'},
    {name:'威海市',total:'3000',percent:'0.09'},
    {name:'通辽市',total:'2950',percent:'0.09'},
    {name:'佳木斯市',total:'2905',percent:'0.09'},
    {name:'白银市',total:'2892',percent:'0.09'},
    {name:'丹东市',total:'2889',percent:'0.09'},
    {name:'来宾市',total:'2863',percent:'0.09'},
    {name:'四平市',total:'2853',percent:'0.09'},
    {name:'平凉市',total:'2799',percent:'0.08'},
    {name:'商洛市',total:'2791',percent:'0.08'},
    {name:'阳泉市',total:'2736',percent:'0.08'},
    {name:'汕尾市',total:'2653',percent:'0.08'},
    {name:'巴音郭楞蒙古自治州',total:'2650',percent:'0.08'},
    {name:'呼伦贝尔市',total:'2640',percent:'0.08'},
    {name:'澳门特别行政区',total:'2635',percent:'0.08'},
    {name:'贺州市',total:'2620',percent:'0.08'},
    {name:'陇南市',total:'2575',percent:'0.08'},
    {name:'松原市',total:'2451',percent:'0.07'},
    {name:'抚顺市',total:'2430',percent:'0.07'},
    {name:'铁岭市',total:'2389',percent:'0.07'},
    {name:'武威市',total:'2382',percent:'0.07'},
    {name:'营口市',total:'2356',percent:'0.07'},
    {name:'琼海市',total:'2349',percent:'0.07'},
    {name:'陵水黎族自治县',total:'2332',percent:'0.07'},
    {name:'楚雄彝族自治州',total:'2245',percent:'0.07'},
    {name:'玉溪市',total:'2242',percent:'0.07'},
    {name:'鄂尔多斯市',total:'2170',percent:'0.07'},
    {name:'延安市',total:'2167',percent:'0.07'},
    {name:'阿克苏地区',total:'2124',percent:'0.06'},
    {name:'舟山市',total:'2118',percent:'0.06'},
    {name:'博尔塔拉蒙古自治州',total:'2064',percent:'0.06'},
    {name:'乌兰察布市',total:'2064',percent:'0.06'},
    {name:'通化市',total:'2035',percent:'0.06'},
    {name:'西双版纳傣族自治州',total:'2023',percent:'0.06'},
    {name:'文山壮族苗族自治州',total:'1968',percent:'0.06'},
    {name:'万宁市',total:'1966',percent:'0.06'},
    {name:'拉萨市',total:'1926',percent:'0.06'},
    {name:'塔城地区',total:'1924',percent:'0.06'},
    {name:'吴忠市',total:'1917',percent:'0.06'},
    {name:'本溪市',total:'1914',percent:'0.06'},
    {name:'鸡西市',total:'1894',percent:'0.06'},
    {name:'酒泉市',total:'1885',percent:'0.06'},
    {name:'济源市',total:'1867',percent:'0.06'},
    {name:'莱芜市',total:'1863',percent:'0.06'},
    {name:'澄迈县',total:'1830',percent:'0.06'},
    {name:'张掖市',total:'1782',percent:'0.05'},
    {name:'喀什地区',total:'1759',percent:'0.05'},
    {name:'崇左市',total:'1758',percent:'0.05'},
    {name:'保山市',total:'1719',percent:'0.05'},
    {name:'云浮市',total:'1702',percent:'0.05'},
    {name:'双鸭山市',total:'1671',percent:'0.05'},
    {name:'巴彦淖尔市',total:'1668',percent:'0.05'},
    {name:'文昌市',total:'1645',percent:'0.05'},
    {name:'白城市',total:'1641',percent:'0.05'},
    {name:'防城港市',total:'1617',percent:'0.05'},
    {name:'盘锦市',total:'1596',percent:'0.05'},
    {name:'阜新市',total:'1582',percent:'0.05'},
    {name:'辽阳市',total:'1552',percent:'0.05'},
    {name:'雅安市',total:'1545',percent:'0.05'},
    {name:'海东市',total:'1489',percent:'0.05'},
    {name:'攀枝花市',total:'1480',percent:'0.04'},
    {name:'固原市',total:'1395',percent:'0.04'},
    {name:'哈密市',total:'1395',percent:'0.04'},
    {name:'兴安盟',total:'1348',percent:'0.04'},
    {name:'白山市',total:'1339',percent:'0.04'},
    {name:'黑河市',total:'1336',percent:'0.04'},
    {name:'普洱市',total:'1327',percent:'0.04'},
    {name:'鹤岗市',total:'1273',percent:'0.04'},
    {name:'中卫市',total:'1243',percent:'0.04'},
    {name:'锡林郭勒盟',total:'1237',percent:'0.04'},
    {name:'乐东黎族自治县',total:'1206',percent:'0.04'},
    {name:'石嘴山市',total:'1144',percent:'0.03'},
    {name:'临沧市',total:'1120',percent:'0.03'},
    {name:'临夏回族自治州',total:'1111',percent:'0.03'},
    {name:'石河子市',total:'1099',percent:'0.03'},
    {name:'东方市',total:'1047',percent:'0.03'},
    {name:'阿勒泰地区',total:'1039',percent:'0.03'},
    {name:'伊春市',total:'1032',percent:'0.03'},
    {name:'克拉玛依市',total:'1003',percent:'0.03'},
    {name:'金昌市',total:'988',percent:'0.03'},
    {name:'德宏傣族景颇族自治州',total:'966',percent:'0.03'},
    {name:'铜川市',total:'943',percent:'0.03'},
    {name:'和田地区',total:'930',percent:'0.03'},
    {name:'辽源市',total:'894',percent:'0.03'},
    {name:'七台河市',total:'810',percent:'0.02'},
    {name:'吐鲁番市',total:'756',percent:'0.02'},
    {name:'嘉峪关市',total:'747',percent:'0.02'},
    {name:'乌海市',total:'726',percent:'0.02'},
    {name:'海西蒙古族藏族自治州',total:'666',percent:'0.02'},
    {name:'定安县',total:'645',percent:'0.02'},
    {name:'阿坝藏族羌族自治州',total:'576',percent:'0.02'},
    {name:'阿拉善盟',total:'471',percent:'0.01'},
    {name:'保亭黎族苗族自治县',total:'463',percent:'0.01'},
    {name:'昌江黎族自治县',total:'462',percent:'0.01'},
    {name:'日喀则市',total:'456',percent:'0.01'},
    {name:'大兴安岭地区',total:'454',percent:'0.01'},
    {name:'山南市',total:'442',percent:'0.01'},
    {name:'迪庆藏族自治州',total:'427',percent:'0.01'},
    {name:'孜勒苏柯尔克孜自治州',total:'393',percent:'0.01'},
    {name:'甘南藏族自治州',total:'370',percent:'0.01'},
    {name:'五指山市',total:'349',percent:'0.01'},
    {name:'阿拉尔市',total:'343',percent:'0.01'},
    {name:'甘孜藏族自治州',total:'333',percent:'0.01'},
    {name:'屯昌县',total:'315',percent:'0.01'},
    {name:'林芝市',total:'285',percent:'0.01'},
    {name:'五家渠市',total:'277',percent:'0.01'},
    {name:'白沙黎族自治县',total:'265',percent:'0.01'},
    {name:'怒江傈僳族自治州',total:'261',percent:'0.01'},
    {name:'昌都市',total:'250',percent:'0.01'},
    {name:'琼中黎族苗族自治县',total:'237',percent:'0.01'},
    {name:'海北藏族自治州',total:'210',percent:'0.01'},
    {name:'海南藏族自治州',total:'202',percent:'0.01'},
    {name:'那曲市',total:'144',percent:'0.00'},
    {name:'图木舒克市',total:'130',percent:'0.00'},
    {name:'玉树藏族自治州',total:'114',percent:'0.00'},
    {name:'阿里地区',total:'84',percent:'0.00'},
    {name:'黄南藏族自治州',total:'72',percent:'0.00'},
    {name:'果洛藏族自治州',total:'54',percent:'0.00'},
    {name:'三沙市',total:'18',percent:'0.00'},
];
// 动态气泡词云
export const activeBubbleData = [
    {"name":"有车一族","count":"300"},
    {"name":"游戏达人","count":"210"},
    {"name":"音乐爱好者","count":"240"},
    {"name":"亲子一族","count":"280"},
    {"name":"教育达人","count":"310"},
    {"name":"外卖一族","count":"200"},
    {"name":"信贷一族","count":"200"},
    {"name":"美拍达人","count":"200"},
    {"name":"购物达人","count":"400"},
    {"name":"知识达人","count":"300"},
    {"name":"美食达人","count":"200"},
    {"name":"社交达人","count":"230"},
    {"name":"健身达人","count":"400"},
    {"name":"房产关注者","count":"400"},
    {"name":"保险达人","count":"270"},
    {"name":"理财达人","count":"310"},
    {"name":"电影爱好者","count":"280"},
    {"name":"出差达人","count":"210"},
    {"name":"家居装修","count":"400"},
    {"name":"爱美一族","count":"200"},
    {"name":"国内游","count":"380"},
    {"name":"境外游","count":"400"},
    {"name":"心理健康","count":"200"},
    {"name":"保健养生","count":"300"},
    {"name":"美容整形","count":"350"},
    {"name":"减肥瘦身","count":"300"},
    {"name":"摄影摄像","count":"200"},
    {"name":"智能设备","count":"400"},
    {"name":"出国留学","count":"400"},
    {"name":"休闲娱乐","count":"200"},
    {"name":"母婴人群","count":"400"},
    {"name":"母婴护理","count":"400"},
    {"name":"美容护肤","count":"200"},
    {"name":"体育运动","count":"200"},
    {"name":"餐饮美食","count":"200"},
    {"name":"房产交易","count":"400"},
    {"name":"房屋租赁","count":"230"},
    {"name":"生活服务","count":"260"},
    {"name":"宠物达人","count":"230"},
    {"name":"服装零售","count":"200"},
    {"name":"IT消费电子","count":"400"}
];
// 关联排行表数据
export const relationData = [
    {
        first: 6.17,
        sec: 7.93,
        third: 9.85
    },
    {
        first: 11.17,
        sec: 11.45,
        third: 12.45
    },
    {
        first: 14.41,
        sec: 14.08,
        third: 14.31
    },
    {
        first: 14.39,
        sec: 14.03,
        third: 13.53
    },
    {
        first: 12.41,
        sec: 12.15,
        third: 11.53
    },
    {
        first: 9.87,
        sec: 9.79,
        third: "9.00"
    },
    {
        first: 7.61,
        sec: 7.55,
        third: "7.00"
    }
];
// 双柱chart数据
export const activeTwoBarData = {
    data: [
        [8, 12, 17, 24, 29, 36, 41, 46, 49, 53],
        [92, 88, 83, 76, 71, 64, 59, 54, 51, 47]
    ],
    xData: ["2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022"]
};
// 动态柱状折线图
export const activeLineBarData = {
    data: {
        bar: [[14, 21, 21, 21, 9, 5, 9], [10, 9, 15, 16, 18, 16, 16]],
        line: [142, 228, 138, 129, 50, 32, 58]
    },
    xData: [ "4-14岁", "15-24", "25-34", "35-44", "45-54", "55-64", "≥65岁"],
};
// 多柱状图
export const barsData = {
    data: [
        [8, 12, 17, 24, 29, 36, 41, 46, 49, 53],
        [92, 88, 83, 76, 71, 64, 59, 54, 51, 47],
        [12, 38, 23, 56, 61, 84, 79, 26, 15, 87]
    ],
    xData: ["2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022"]
};
// 双y轴图
export const twoyData = {
    data: {
        bar: [
            [2.0, 4.9, 7.0, 23.2, 25.6, 76.7, 135.6, 162.2, 32.6, 20.0, 6.4, 3.3],
            [2.6, 5.9, 9.0, 26.4, 28.7, 70.7, 175.6, 182.2, 48.7, 18.8, 6.0, 2.3]
        ],
        line: [
            [2.0, 2.2, 3.3, 4.5, 6.3, 10.2, 20.3, 23.4, 23.0, 16.5, 12.0, 6.2]
        ]
    },
    xData: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月']
};
// 相关气泡数据
export const relationScatterData = [
    [[28604,77,17096869,'Australia',1990],[31163,77.4,27662440,'Canada',1990],[1516,68,1154605773,'China',1990],[13670,74.7,10582082,'Cuba',1990],[28599,75,4986705,'Finland',1990],[29476,77.1,56943299,'France',1990],[31476,75.4,78958237,'Germany',1990],[28666,78.1,254830,'Iceland',1990],[1777,57.7,870601776,'India',1990],[29550,79.1,122249285,'Japan',1990],[2076,67.9,20194354,'North Korea',1990],[12087,72,42972254,'South Korea',1990],[24021,75.4,3397534,'New Zealand',1990],[43296,76.8,4240375,'Norway',1990],[10088,70.8,38195258,'Poland',1990],[19349,69.6,147568552,'Russia',1990],[10670,67.3,53994605,'Turkey',1990],[26424,75.7,57110117,'United Kingdom',1990],[37062,75.4,252847810,'United States',1990]],
    [[44056,81.8,23968973,'Australia',2015],[43294,81.7,35939927,'Canada',2015],[13334,76.9,1376048943,'China',2015],[21291,78.5,11389562,'Cuba',2015],[38923,80.8,5503457,'Finland',2015],[37599,81.9,64395345,'France',2015],[44053,81.1,80688545,'Germany',2015],[42182,82.8,329425,'Iceland',2015],[5903,66.8,1311050527,'India',2015],[36162,83.5,126573481,'Japan',2015],[1390,71.4,25155317,'North Korea',2015],[34644,80.7,50293439,'South Korea',2015],[34186,80.6,4528526,'New Zealand',2015],[64304,81.6,5210967,'Norway',2015],[24787,77.3,38611794,'Poland',2015],[23038,73.13,143456918,'Russia',2015],[19360,76.5,78665830,'Turkey',2015],[38225,81.4,64715810,'United Kingdom',2015],[53354,79.1,321773631,'United States',2015]]
];
// 雷达图
export const radarData = {
    data: [
        [4300, 10000, 28000, 35000, 50000, 19000],
        [5000, 14000, 28000, 31000, 42000, 21000]
    ],
    item: [
        { name: '销售', max: 6500},
        { name: '管理', max: 16000},
        { name: '信息技术', max: 30000},
        { name: '客服', max: 38000},
        { name: '研发', max: 52000},
        { name: '市场', max: 25000}
    ]
};
// 漏斗图
export const funnelData = [
    {value: 60, name: '访问'},
    {value: 40, name: '咨询'},
    {value: 20, name: '订单'},
    {value: 80, name: '点击'},
    {value: 100, name: '展现'}
];
// 锥形柱图
export const coneData = function () {
    let picPath = [
        'path://M-22.788,24.521c2.08-0.986,3.611-3.905,4.984-5.892 c-2.686,2.782-5.047,5.884-9.102,7.312c-0.992,0.005-0.25-2.016,0.34-2.362l1.852-0.41c0.564-0.218,0.785-0.842,0.902-1.347 c2.133-0.727,4.91-4.129,6.031-6.194c1.748-0.7,4.443-0.679,5.734-2.293c1.176-1.468,0.393-3.992,1.215-6.557 c0.24-0.754,0.574-1.581,1.008-2.293c-0.611,0.011-1.348-0.061-1.959-0.608c-1.391-1.245-0.785-2.086-1.297-3.313 c1.684,0.744,2.5,2.584,4.426,2.586C-8.46,3.012-8.255,2.901-8.04,2.824c6.031-1.952,15.182-0.165,19.498-3.937 c1.15-3.933-1.24-9.846-1.229-9.938c0.008-0.062-1.314-0.004-1.803-0.258c-1.119-0.771-6.531-3.75-0.17-3.33 c0.314-0.045,0.943,0.259,1.439,0.435c-0.289-1.694-0.92-0.144-3.311-1.946c0,0-1.1-0.855-1.764-1.98 c-0.836-1.09-2.01-2.825-2.992-4.031c-1.523-2.476,1.367,0.709,1.816,1.108c1.768,1.704,1.844,3.281,3.232,3.983 c0.195,0.203,1.453,0.164,0.926-0.468c-0.525-0.632-1.367-1.278-1.775-2.341c-0.293-0.703-1.311-2.326-1.566-2.711 c-0.256-0.384-0.959-1.718-1.67-2.351c-1.047-1.187-0.268-0.902,0.521-0.07c0.789,0.834,1.537,1.821,1.672,2.023 c0.135,0.203,1.584,2.521,1.725,2.387c0.102-0.259-0.035-0.428-0.158-0.852c-0.125-0.423-0.912-2.032-0.961-2.083 c-0.357-0.852-0.566-1.908-0.598-3.333c0.4-2.375,0.648-2.486,0.549-0.705c0.014,1.143,0.031,2.215,0.602,3.247 c0.807,1.496,1.764,4.064,1.836,4.474c0.561,3.176,2.904,1.749,2.281-0.126c-0.068-0.446-0.109-2.014-0.287-2.862 c-0.18-0.849-0.219-1.688-0.113-3.056c0.066-1.389,0.232-2.055,0.277-2.299c0.285-1.023,0.4-1.088,0.408,0.135 c-0.059,0.399-0.131,1.687-0.125,2.655c0.064,0.642-0.043,1.768,0.172,2.486c0.654,1.928-0.027,3.496,1,3.514 c1.805-0.424,2.428-1.218,2.428-2.346c-0.086-0.704-0.121-0.843-0.031-1.193c0.221-0.568,0.359-0.67,0.312-0.076 c-0.055,0.287,0.031,0.533,0.082,0.794c0.264,1.197,0.912,0.114,1.283-0.782c0.15-0.238,0.539-2.154,0.545-2.522 c-0.023-0.617,0.285-0.645,0.309,0.01c0.064,0.422-0.248,2.646-0.205,2.334c-0.338,1.24-1.105,3.402-3.379,4.712 c-0.389,0.12-1.186,1.286-3.328,2.178c0,0,1.729,0.321,3.156,0.246c1.102-0.19,3.707-0.027,4.654,0.269 c1.752,0.494,1.531-0.053,4.084,0.164c2.26-0.4,2.154,2.391-1.496,3.68c-2.549,1.405-3.107,1.475-2.293,2.984 c3.484,7.906,2.865,13.183,2.193,16.466c2.41,0.271,5.732-0.62,7.301,0.725c0.506,0.333,0.648,1.866-0.457,2.86 c-4.105,2.745-9.283,7.022-13.904,7.662c-0.977-0.194,0.156-2.025,0.803-2.247l1.898-0.03c0.596-0.101,0.936-0.669,1.152-1.139 c3.16-0.404,5.045-3.775,8.246-4.818c-4.035-0.718-9.588,3.981-12.162,1.051c-5.043,1.423-11.449,1.84-15.895,1.111 c-3.105,2.687-7.934,4.021-12.115,5.866c-3.271,3.511-5.188,8.086-9.967,10.414c-0.986,0.119-0.48-1.974,0.066-2.385l1.795-0.618 C-22.995,25.682-22.849,25.035-22.788,24.521z',
        'path://M1.112,32.559l2.998,1.205l-2.882,2.268l-2.215-0.012L1.112,32.559z M37.803,23.96 c0.158-0.838,0.5-1.509,0.961-1.904c-0.096-0.037-0.205-0.071-0.344-0.071c-0.777-0.005-2.068-0.009-3.047-0.009 c-0.633,0-1.217,0.066-1.754,0.18l2.199,1.804H37.803z M39.738,23.036c-0.111,0-0.377,0.325-0.537,0.924h1.076 C40.115,23.361,39.854,23.036,39.738,23.036z M39.934,39.867c-0.166,0-0.674,0.705-0.674,1.986s0.506,1.986,0.674,1.986 s0.672-0.705,0.672-1.986S40.102,39.867,39.934,39.867z M38.963,38.889c-0.098-0.038-0.209-0.07-0.348-0.073 c-0.082,0-0.174,0-0.268-0.001l-7.127,4.671c0.879,0.821,2.42,1.417,4.348,1.417c0.979,0,2.27-0.006,3.047-0.01 c0.139,0,0.25-0.034,0.348-0.072c-0.646-0.555-1.07-1.643-1.07-2.967C37.891,40.529,38.316,39.441,38.963,38.889z M32.713,23.96 l-12.37-10.116l-4.693-0.004c0,0,4,8.222,4.827,10.121H32.713z M59.311,32.374c-0.248,2.104-5.305,3.172-8.018,3.172H39.629 l-25.325,16.61L9.607,52.16c0,0,6.687-8.479,7.95-10.207c1.17-1.6,3.019-3.699,3.027-6.407h-2.138 c-5.839,0-13.816-3.789-18.472-5.583c-2.818-1.085-2.396-4.04-0.031-4.04h0.039l-3.299-11.371h3.617c0,0,4.352,5.696,5.846,7.5 c2,2.416,4.503,3.678,8.228,3.87h30.727c2.17,0,4.311,0.417,6.252,1.046c3.49,1.175,5.863,2.7,7.199,4.027 C59.145,31.584,59.352,32.025,59.311,32.374z M22.069,30.408c0-0.815-0.661-1.475-1.469-1.475c-0.812,0-1.471,0.66-1.471,1.475 s0.658,1.475,1.471,1.475C21.408,31.883,22.069,31.224,22.069,30.408z M27.06,30.408c0-0.815-0.656-1.478-1.466-1.478 c-0.812,0-1.471,0.662-1.471,1.478s0.658,1.477,1.471,1.477C26.404,31.885,27.06,31.224,27.06,30.408z M32.055,30.408 c0-0.815-0.66-1.475-1.469-1.475c-0.808,0-1.466,0.66-1.466,1.475s0.658,1.475,1.466,1.475 C31.398,31.883,32.055,31.224,32.055,30.408z M37.049,30.408c0-0.815-0.658-1.478-1.467-1.478c-0.812,0-1.469,0.662-1.469,1.478 s0.656,1.477,1.469,1.477C36.389,31.885,37.049,31.224,37.049,30.408z M42.039,30.408c0-0.815-0.656-1.478-1.465-1.478 c-0.811,0-1.469,0.662-1.469,1.478s0.658,1.477,1.469,1.477C41.383,31.885,42.039,31.224,42.039,30.408z M55.479,30.565 c-0.701-0.436-1.568-0.896-2.627-1.347c-0.613,0.289-1.551,0.476-2.73,0.476c-1.527,0-1.639,2.263,0.164,2.316 C52.389,32.074,54.627,31.373,55.479,30.565z',
        'path://M-244.396,44.399c0,0,0.47-2.931-2.427-6.512c2.819-8.221,3.21-15.709,3.21-15.709s5.795,1.383,5.795,7.325C-237.818,39.679-244.396,44.399-244.396,44.399z M-260.371,40.827c0,0-3.881-12.946-3.881-18.319c0-2.416,0.262-4.566,0.669-6.517h17.684c0.411,1.952,0.675,4.104,0.675,6.519c0,5.291-3.87,18.317-3.87,18.317H-260.371z M-254.745,18.951c-1.99,0-3.603,1.676-3.603,3.744c0,2.068,1.612,3.744,3.603,3.744c1.988,0,3.602-1.676,3.602-3.744S-252.757,18.951-254.745,18.951z M-255.521,2.228v-5.098h1.402v4.969c1.603,1.213,5.941,5.069,7.901,12.5h-17.05C-261.373,7.373-257.245,3.558-255.521,2.228zM-265.07,44.399c0,0-6.577-4.721-6.577-14.896c0-5.942,5.794-7.325,5.794-7.325s0.393,7.488,3.211,15.708C-265.539,41.469-265.07,44.399-265.07,44.399z M-252.36,45.15l-1.176-1.22L-254.789,48l-1.487-4.069l-1.019,2.116l-1.488-3.826h8.067L-252.36,45.15z',
        'path://M67.335,33.596L67.335,33.596c-0.002-1.39-1.153-3.183-3.328-4.218h-9.096v-2.07h5.371 c-4.939-2.07-11.199-4.141-14.89-4.141H19.72v12.421v5.176h38.373c4.033,0,8.457-1.035,9.142-5.176h-0.027 c0.076-0.367,0.129-0.751,0.129-1.165L67.335,33.596L67.335,33.596z M27.999,30.413h-3.105v-4.141h3.105V30.413z M35.245,30.413 h-3.104v-4.141h3.104V30.413z M42.491,30.413h-3.104v-4.141h3.104V30.413z M49.736,30.413h-3.104v-4.141h3.104V30.413z  M14.544,40.764c1.143,0,2.07-0.927,2.07-2.07V35.59V25.237c0-1.145-0.928-2.07-2.07-2.07H-9.265c-1.143,0-2.068,0.926-2.068,2.07 v10.351v3.105c0,1.144,0.926,2.07,2.068,2.07H14.544L14.544,40.764z M8.333,26.272h3.105v4.141H8.333V26.272z M1.087,26.272h3.105 v4.141H1.087V26.272z M-6.159,26.272h3.105v4.141h-3.105V26.272z M-9.265,41.798h69.352v1.035H-9.265V41.798z',
        'path://M16.678,17.086h9.854l-2.703,5.912c5.596,2.428,11.155,5.575,16.711,8.607c3.387,1.847,6.967,3.75,10.541,5.375 v-6.16l-4.197-2.763v-5.318L33.064,12.197h-11.48L20.43,15.24h-4.533l-1.266,3.286l0.781,0.345L16.678,17.086z M49.6,31.84 l0.047,1.273L27.438,20.998l0.799-1.734L49.6,31.84z M33.031,15.1l12.889,8.82l0.027,0.769L32.551,16.1L33.031,15.1z M22.377,14.045 h9.846l-1.539,3.365l-2.287-1.498h1.371l0.721-1.352h-2.023l-0.553,1.037l-0.541-0.357h-0.34l0.359-0.684h-2.025l-0.361,0.684 h-3.473L22.377,14.045z M23.695,20.678l-0.004,0.004h0.004V20.678z M24.828,18.199h-2.031l-0.719,1.358h2.029L24.828,18.199z  M40.385,34.227c-12.85-7.009-25.729-14.667-38.971-12.527c1.26,8.809,9.08,16.201,8.213,24.328 c-0.553,4.062-3.111,0.828-3.303,7.137c15.799,0,32.379,0,48.166,0l0.066-4.195l1.477-7.23 C50.842,39.812,45.393,36.961,40.385,34.227z M13.99,35.954c-1.213,0-2.195-1.353-2.195-3.035c0-1.665,0.98-3.017,2.195-3.017 c1.219,0,2.195,1.352,2.195,3.017C16.186,34.604,15.213,35.954,13.99,35.954z M23.691,20.682h-2.02l-0.588,1.351h2.023 L23.691,20.682z M19.697,18.199l-0.721,1.358h2.025l0.727-1.358H19.697z',
        'path://M49.592,40.883c-0.053,0.354-0.139,0.697-0.268,0.963c-0.232,0.475-0.455,0.519-1.334,0.475 c-1.135-0.053-2.764,0-4.484,0.068c0,0.476,0.018,0.697,0.018,0.697c0.111,1.299,0.697,1.342,0.931,1.342h3.7 c0.326,0,0.628,0,0.861-0.154c0.301-0.196,0.43-0.772,0.543-1.78c0.017-0.146,0.025-0.336,0.033-0.56v-0.01 c0-0.068,0.008-0.154,0.008-0.25V41.58l0,0C49.6,41.348,49.6,41.09,49.592,40.883L49.592,40.883z M6.057,40.883 c0.053,0.354,0.137,0.697,0.268,0.963c0.23,0.475,0.455,0.519,1.334,0.475c1.137-0.053,2.762,0,4.484,0.068 c0,0.476-0.018,0.697-0.018,0.697c-0.111,1.299-0.697,1.342-0.93,1.342h-3.7c-0.328,0-0.602,0-0.861-0.154 c-0.309-0.18-0.43-0.772-0.541-1.78c-0.018-0.146-0.027-0.336-0.035-0.56v-0.01c0-0.068-0.008-0.154-0.008-0.25V41.58l0,0 C6.057,41.348,6.057,41.09,6.057,40.883L6.057,40.883z M49.867,32.766c0-2.642-0.344-5.224-0.482-5.507 c-0.104-0.207-0.766-0.749-2.271-1.773c-1.522-1.042-1.487-0.887-1.766-1.566c0.25-0.078,0.492-0.224,0.639-0.241 c0.326-0.034,0.345,0.274,1.023,0.274c0.68,0,2.152-0.18,2.453-0.48c0.301-0.303,0.396-0.405,0.396-0.672 c0-0.268-0.156-0.818-0.447-1.146c-0.293-0.327-1.541-0.49-2.273-0.585c-0.729-0.095-0.834,0-1.022,0.121 c-0.304,0.189-0.32,1.919-0.32,1.919l-0.713,0.018c-0.465-1.146-1.11-3.452-2.117-5.269c-1.103-1.979-2.256-2.599-2.737-2.754 c-0.474-0.146-0.904-0.249-4.131-0.576c-3.298-0.344-5.922-0.388-8.262-0.388c-2.342,0-4.967,0.052-8.264,0.388 c-3.229,0.336-3.66,0.43-4.133,0.576s-1.633,0.775-2.736,2.754c-1.006,1.816-1.652,4.123-2.117,5.269L9.87,23.109 c0,0-0.008-1.729-0.318-1.919c-0.189-0.121-0.293-0.225-1.023-0.121c-0.732,0.104-1.98,0.258-2.273,0.585 c-0.293,0.327-0.447,0.878-0.447,1.146c0,0.267,0.094,0.379,0.396,0.672c0.301,0.301,1.773,0.48,2.453,0.48 c0.68,0,0.697-0.309,1.023-0.274c0.146,0.018,0.396,0.163,0.637,0.241c-0.283,0.68-0.24,0.524-1.764,1.566 c-1.506,1.033-2.178,1.566-2.271,1.773c-0.139,0.283-0.482,2.865-0.482,5.508s0.189,5.02,0.189,5.86c0,0.354,0,0.976,0.076,1.565 c0.053,0.354,0.129,0.697,0.268,0.966c0.232,0.473,0.447,0.516,1.334,0.473c1.137-0.051,2.779,0,4.477,0.07 c1.135,0.043,2.297,0.086,3.33,0.11c2.582,0.051,1.826-0.379,2.928-0.36c1.102,0.016,5.447,0.196,9.424,0.196 c3.976,0,8.332-0.182,9.423-0.196c1.102-0.019,0.346,0.411,2.926,0.36c1.033-0.018,2.195-0.067,3.332-0.11 c1.695-0.062,3.348-0.121,4.477-0.07c0.886,0.043,1.103,0,1.332-0.473c0.132-0.269,0.218-0.611,0.269-0.966 c0.086-0.592,0.078-1.213,0.078-1.565C49.678,37.793,49.867,35.408,49.867,32.766L49.867,32.766z M13.219,19.735 c0.412-0.964,1.652-2.9,2.256-3.244c0.145-0.087,1.426-0.491,4.637-0.706c2.953-0.198,6.217-0.276,7.73-0.276 c1.513,0,4.777,0.078,7.729,0.276c3.201,0.215,4.502,0.611,4.639,0.706c0.775,0.533,1.842,2.28,2.256,3.244 c0.412,0.965,0.965,2.858,0.861,3.116c-0.104,0.258,0.104,0.388-1.291,0.275c-1.387-0.103-10.088-0.216-14.185-0.216 c-4.088,0-12.789,0.113-14.184,0.216c-1.395,0.104-1.188-0.018-1.291-0.275C12.254,22.593,12.805,20.708,13.219,19.735 L13.219,19.735z M16.385,30.511c-0.619,0.155-0.988,0.491-1.764,0.482c-0.775,0-2.867-0.353-3.314-0.371 c-0.447-0.017-0.842,0.302-1.076,0.362c-0.23,0.06-0.688-0.104-1.377-0.318c-0.688-0.216-1.092-0.155-1.316-1.094 c-0.232-0.93,0-2.264,0-2.264c1.488-0.068,2.928,0.069,5.621,0.826c2.693,0.758,4.191,2.213,4.191,2.213 S17.004,30.357,16.385,30.511L16.385,30.511z M36.629,37.293c-1.23,0.164-6.386,0.207-8.794,0.207c-2.412,0-7.566-0.051-8.799-0.207 c-1.256-0.164-2.891-1.67-1.764-2.865c1.523-1.627,1.24-1.576,4.701-2.023C24.967,32.018,27.239,32,27.834,32 c0.584,0,2.865,0.025,5.859,0.404c3.461,0.447,3.178,0.396,4.699,2.022C39.521,35.623,37.887,37.129,36.629,37.293L36.629,37.293z  M48.129,29.582c-0.232,0.93-0.629,0.878-1.318,1.093c-0.688,0.216-1.145,0.371-1.377,0.319c-0.231-0.053-0.627-0.371-1.074-0.361 c-0.448,0.018-2.539,0.37-3.313,0.37c-0.772,0-1.146-0.328-1.764-0.481c-0.621-0.154-0.966-0.154-0.966-0.154 s1.49-1.464,4.191-2.213c2.693-0.758,4.131-0.895,5.621-0.826C48.129,27.309,48.361,28.643,48.129,29.582L48.129,29.582z',
        'path://M13.676,32.955c0.919-0.031,1.843-0.008,2.767-0.008v0.007c0.827,0,1.659,0.041,2.486-0.019 c0.417-0.028,1.118,0.325,1.14-0.545c0.014-0.637-0.156-1.279-0.873-1.367c-1.919-0.241-3.858-0.233-5.774,0.019 c-0.465,0.062-0.998,0.442-0.832,1.069C12.715,32.602,13.045,32.977,13.676,32.955z M14.108,29.013 c1.47-0.007,2.96-0.122,4.414,0.035c1.792,0.192,3.1-0.412,4.273-2.105c-3.044,0-5.882,0.014-8.719-0.01 c-0.768-0.005-1.495,0.118-1.461,1C12.642,28.731,13.329,29.014,14.108,29.013z M23.678,36.593c-0.666-0.69-1.258-1.497-2.483-1.448 c-2.341,0.095-4.689,0.051-7.035,0.012c-0.834-0.014-1.599,0.177-1.569,1.066c0.031,0.854,0.812,1.062,1.636,1.043 c1.425-0.033,2.852-0.01,4.278-0.01v-0.01c1.562,0,3.126,0.008,4.691-0.005C23.614,37.239,24.233,37.174,23.678,36.593z  M32.234,42.292h-0.002c-1.075,0.793-2.589,0.345-3.821,1.048c-0.359,0.193-0.663,0.465-0.899,0.799 c-1.068,1.623-2.052,3.301-3.117,4.928c-0.625,0.961-0.386,1.805,0.409,2.395c0.844,0.628,1.874,0.617,2.548-0.299 c1.912-2.573,3.761-5.197,5.621-7.814C33.484,42.619,33.032,42.387,32.234,42.292z M43.527,28.401 c-0.688-1.575-2.012-0.831-3.121-0.895c-1.047-0.058-2.119,1.128-3.002,0.345c-0.768-0.677-1.213-1.804-1.562-2.813 c-0.45-1.305-1.495-2.225-2.329-3.583c2.953,1.139,4.729,0.077,5.592-1.322c0.99-1.61,0.718-3.725-0.627-4.967 c-1.362-1.255-3.414-1.445-4.927-0.452c-1.933,1.268-2.206,2.893-0.899,6.11c-2.098-0.659-3.835-1.654-5.682-2.383 c-0.735-0.291-1.437-1.017-2.293-0.666c-2.263,0.927-4.522,1.885-6.723,2.95c-1.357,0.658-1.649,1.593-1.076,2.638 c0.462,0.851,1.643,1.126,2.806,0.617c0.993-0.433,1.994-0.857,2.951-1.374c1.599-0.86,3.044-0.873,4.604,0.214 c1.017,0.707,0.873,1.137,0.123,1.849c-1.701,1.615-3.516,3.12-4.933,5.006c-1.042,1.388-0.993,2.817,0.255,4.011 c1.538,1.471,3.148,2.869,4.708,4.315c0.485,0.444,0.907,0.896-0.227,1.104c-1.523,0.285-3.021,0.694-4.538,1.006 c-1.109,0.225-2.02,1.259-1.83,2.16c0.223,1.07,1.548,1.756,2.687,1.487c3.003-0.712,6.008-1.413,9.032-2.044 c1.549-0.324,2.273-1.869,1.344-3.115c-0.868-1.156-1.801-2.267-2.639-3.445c-1.964-2.762-1.95-2.771,0.528-5.189 c1.394-1.357,1.379-1.351,2.437,0.417c0.461,0.769,0.854,1.703,1.99,1.613c2.238-0.181,4.407-0.755,6.564-1.331 C43.557,30.447,43.88,29.206,43.527,28.401z',
        'path://M29.902,23.275c1.86,0,3.368-1.506,3.368-3.365c0-1.859-1.508-3.365-3.368-3.365 c-1.857,0-3.365,1.506-3.365,3.365C26.537,21.769,28.045,23.275,29.902,23.275z M36.867,30.74c-1.666-0.467-3.799-1.6-4.732-4.199 c-0.932-2.6-3.131-2.998-4.797-2.998s-7.098,3.894-7.098,3.894c-1.133,1.001-2.1,6.502-0.967,6.769 c1.133,0.269,1.266-1.533,1.934-3.599c0.666-2.065,3.797-3.466,3.797-3.466s0.201,2.467-0.398,3.866 c-0.599,1.399-1.133,2.866-1.467,6.198s-1.6,3.665-3.799,6.266c-2.199,2.598-0.6,3.797,0.398,3.664 c1.002-0.133,5.865-5.598,6.398-6.998c0.533-1.397,0.668-3.732,0.668-3.732s0,0,2.199,1.867c2.199,1.865,2.332,4.6,2.998,7.73 s2.332,0.934,2.332-0.467c0-1.401,0.269-5.465-1-7.064c-1.265-1.6-3.73-3.465-3.73-5.265s1.199-3.732,1.199-3.732 c0.332,1.667,3.335,3.065,5.599,3.399C38.668,33.206,38.533,31.207,36.867,30.74z'
    ];
    let xData = ['驯鹿', '火箭', '飞机', '高铁', '轮船', '汽车', '跑步', '步行'];
    let relationPath = {};
    for (let i=0; i<xData.length; i++) {
        relationPath[xData[i]] = picPath[i];
    }
    return [{
        name: xData[0],
        value: 123,
        symbol: picPath[0],
        symbolSize: [60, 60]
    }, {
        name: xData[1],
        value: 60,
        symbol: picPath[1],
        symbolSize: [50, 60]
    }, {
        name: xData[2],
        value: 25,
        symbol: picPath[2],
        symbolSize: [65, 35]
    }, {
        name: xData[3],
        value: 18,
        symbol: picPath[3],
        symbolSize: [50, 30]
    }, {
        name: xData[4],
        value: 12,
        symbol: picPath[4],
        symbolSize: [50, 35]
    }, {
        name: xData[5],
        value: 9,
        symbol: picPath[5],
        symbolSize: [40, 30]
    }, {
        name: xData[6],
        value: 2,
        symbol: picPath[6],
        symbolSize: [40, 50]
    }, {
        name: xData[7],
        value: 1,
        symbol: picPath[7],
        symbolSize: [40, 50]
    }]
};
// 个性柱状图
export const customBarData = {
    data: {
        line: [228.8, 174.4, 87.3, 73.5, 243.1, 70.4, 167.7, 219.9, 275.1, 170.5, 169.0, 251.9, 136.2, 149.7, 326.2, 74.2, 119.7, 329.0, 235.0, 256.5],
        bar: [69.5, 96.1, 23.7, 28.0, 172.6, 7.9, 23.1, 29.6, 176.5, 30.3, 168.9, 118.7, 25.3, 34.5, 151.9, 53.6, 75.8, 199.6, 117.1, 76.6]
    },
    xData: ["2020-3-26", "2020-3-27", "2020-3-28", "2020-3-29", "2020-3-30", "2020-3-31", "2020-4-1", "2020-4-2", "2020-4-3", "2020-4-4", "2020-4-5", "2020-4-6", "2020-4-7", "2020-4-8", "2020-4-9", "2020-4-10", "2020-4-11", "2020-4-12", "2020-4-13", "2020-4-14"]
};